var $PJwWZ$proptypes = require("prop-types");
var $PJwWZ$reactprocessstring = require("react-process-string");
var $PJwWZ$ramda = require("ramda");
var $PJwWZ$emojiregex = require("emoji-regex");
var $PJwWZ$hashtagregex = require("hashtag-regex");
var $PJwWZ$reactjsxruntime = require("react/jsx-runtime");
require("react");
var $PJwWZ$muimaterial = require("@mui/material");
var $PJwWZ$libphonenumberjs = require("libphonenumber-js");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "TextParser", () => $547b71b758d2d1c0$export$45abb64cb9f69786);
$parcel$export(module.exports, "textParserConfig", () => $47656169c492d9d8$export$ecc56c680df52e50);
$parcel$export(module.exports, "linkRenderer", () => $5bec2caf4e6d13e3$export$2ca3ffb384919372);







function $532c7d8feec646aa$export$7c2ed33b8e391691(args) {
    return function(index, [entry]) {
        return /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)("em-emoji", {
            spritesheet: true,
            spritesheeturl: args === null || args === void 0 ? void 0 : args.spritesheeturl,
            style: {
                verticalAlign: "top",
                display: "inline-block"
            },
            native: entry,
            set: "apple",
            size: 18
        }, index);
    };
}




const $a5e42debdb619001$var$codeStyle = {
    fontFamily: "monospace !important",
    fontSize: "90%",
    padding: "2px 4px",
    borderRadius: "4px",
    backgroundColor: "#00000017"
};
const $a5e42debdb619001$var$Code = (key, result)=>/*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)("code", {
        dir: "auto",
        className: "c--text-message__code",
        style: $a5e42debdb619001$var$codeStyle,
        children: result[1]
    }, key);
var $a5e42debdb619001$export$2e2bcd8739ae039 = $a5e42debdb619001$var$Code;




const $9044c68812eeffbc$var$Mention = (key, result)=>{
    return /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)("span", {
        className: "c--text-message__mention",
        dir: "ltr",
        children: result[0]
    }, key);
};
var $9044c68812eeffbc$export$2e2bcd8739ae039 = $9044c68812eeffbc$var$Mention;





const $1755f040633aa4a7$var$Highlight = (key, result)=>{
    return /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)((0, $PJwWZ$muimaterial.Typography), {
        variant: "messageRegular",
        sx: {
            backgroundColor: "secondary.light"
        },
        children: result[0]
    }, key);
};
var $1755f040633aa4a7$export$2e2bcd8739ae039 = $1755f040633aa4a7$var$Highlight;





const $5bec2caf4e6d13e3$var$getLink = (text)=>{
    try {
        return decodeURI(text);
    } catch (e) {
        return text;
    }
};
function $5bec2caf4e6d13e3$export$2ca3ffb384919372(args) {
    return function(key, result) {
        const link = $5bec2caf4e6d13e3$var$getLink(result[0]);
        return /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)((0, $PJwWZ$muimaterial.Typography), {
            variant: "messageRegular",
            color: "secondary",
            sx: {
                cursor: "pointer"
            },
            onContextMenu: (e)=>{
                e.stopPropagation();
                e.preventDefault();
                args === null || args === void 0 ? void 0 : args.onContextMenu({
                    link: link
                });
            },
            onClick: ()=>{
                return args === null || args === void 0 ? void 0 : args.onClick(link);
            },
            dir: "ltr",
            children: link
        }, key);
    };
}




function $990bc7e57fd6f777$export$eddc145d3ae2075c(args) {
    return function(key, result) {
        const hashtag = result[0];
        return /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)((0, $PJwWZ$muimaterial.Typography), {
            // @ts-ignore
            variant: "messageRegular",
            color: "secondary",
            sx: {
                cursor: "pointer",
                fontSize: "14px"
            },
            onContextMenu: (e)=>{
                e.stopPropagation();
                e.preventDefault();
                args === null || args === void 0 ? void 0 : args.onContextMenu({
                    hashtag: hashtag
                });
            },
            onClick: ()=>{
                return args === null || args === void 0 ? void 0 : args.onClick(hashtag);
            },
            dir: "auto",
            children: hashtag
        }, key);
    };
}




function $7ecb579c7679222f$export$7b11aaab27e6da4b(args) {
    return function(key, result) {
        var ref;
        const identifier = (ref = result[0]) === null || ref === void 0 ? void 0 : ref.slice(1);
        return /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)((0, $PJwWZ$muimaterial.Typography), {
            // @ts-ignore
            variant: "messageRegular",
            color: "secondary",
            sx: {
                cursor: "pointer",
                fontSize: "14px"
            },
            onClick: async ()=>{
                return await (args === null || args === void 0 ? void 0 : args.onClick(identifier));
            },
            dir: "ltr",
            children: result[0]
        }, key);
    };
}





const $160c5f374e056dc2$var$checkHyperLinkType = (rawText)=>{
    if ($PJwWZ$ramda.test(/\]\(/, rawText || "")) return {
        isMention: false,
        isLink: false
    };
    const split = $PJwWZ$ramda.split("](", rawText);
    const secondPart = $PJwWZ$ramda.init($PJwWZ$ramda.last(split));
    if ($PJwWZ$ramda.startsWith("mention://user_id/", secondPart)) return {
        isMention: true
    };
    return {
        isLink: true
    };
};
function $160c5f374e056dc2$export$f67d7f85eca31cc4(args) {
    return function(key, result) {
        const { isMention: isMention , isLink: isLink  } = $160c5f374e056dc2$var$checkHyperLinkType(result[0]);
        if (isMention) return (0, $9044c68812eeffbc$export$2e2bcd8739ae039)(`${key}-mention`, result);
        if (isLink) return (0, $5bec2caf4e6d13e3$export$2ca3ffb384919372)(args);
        return result[0];
    };
}






function $19695571cfcc95c0$export$4c3f131968b69ab4(args) {
    return function(key, result) {
        const rawPhone = result[0] || "";
        const startsWithPlus = rawPhone.startsWith("+") || rawPhone.startsWith("＋");
        if (startsWithPlus) {
            const phoneNumber = (0, $PJwWZ$libphonenumberjs.parsePhoneNumber)(rawPhone);
            const isPossible = phoneNumber.isPossible();
            return isPossible ? /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)((0, $PJwWZ$muimaterial.Typography), {
                variant: "messageRegular",
                color: "secondary",
                sx: {
                    cursor: "pointer"
                },
                // onClick={() => window.open(phoneNumber.getURI())}
                onClick: async (e)=>{
                    return await (args === null || args === void 0 ? void 0 : args.onClick({
                        phone: phoneNumber.number,
                        clientX: e.clientX,
                        clientY: e.clientY
                    }));
                },
                children: rawPhone
            }, key) : /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)((0, $PJwWZ$muimaterial.Typography), {
                variant: "messageRegular",
                children: rawPhone
            }, key);
        }
        return /*#__PURE__*/ (0, $PJwWZ$reactjsxruntime.jsx)((0, $PJwWZ$muimaterial.Typography), {
            variant: "messageRegular",
            color: "secondary",
            sx: {
                cursor: "pointer"
            },
            onClick: async (e)=>{
                return await (args === null || args === void 0 ? void 0 : args.onClick({
                    phone: rawPhone,
                    clientX: e.clientX,
                    clientY: e.clientY
                }));
            },
            children: rawPhone
        }, key);
    };
}


const $5625d0caec0a5724$export$cd8355bcbe13154 = 2;
const $5625d0caec0a5724$export$85ddd8c9b243679b = 17;
const $5625d0caec0a5724$export$514717690676fb4a = 3;
const $5625d0caec0a5724$export$852d1d4a47329634 = "0-9０-９٠-٩۰-۹";
// `DASHES` will be right after the opening square bracket of the "character class"
const $5625d0caec0a5724$var$DASHES = "-‐-―−ー－";
const $5625d0caec0a5724$var$SLASHES = "／/";
const $5625d0caec0a5724$var$DOTS = "．.";
const $5625d0caec0a5724$export$20542845033f576e = " \xa0\xad​⁠　";
const $5625d0caec0a5724$var$BRACKETS = "()（）［］\\[\\]";
// export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
const $5625d0caec0a5724$var$TILDES = "~⁓∼～";
const $5625d0caec0a5724$export$7f01587e28f9194 = `${$5625d0caec0a5724$var$DASHES}${$5625d0caec0a5724$var$SLASHES}${$5625d0caec0a5724$var$DOTS}${$5625d0caec0a5724$export$20542845033f576e}${$5625d0caec0a5724$var$BRACKETS}${$5625d0caec0a5724$var$TILDES}`;
const $5625d0caec0a5724$export$207c99ccf3902df8 = "+＋";
const $5625d0caec0a5724$export$a77dd7471651eee = "[" + $5625d0caec0a5724$export$207c99ccf3902df8 + "]{0,1}" + "[" + $5625d0caec0a5724$export$852d1d4a47329634 + "]" + "{10,15}";


const $47656169c492d9d8$export$ecc56c680df52e50 = {
    emoji: {
        regex: (0, ($parcel$interopDefault($PJwWZ$emojiregex)))(),
        fn: (0, $532c7d8feec646aa$export$7c2ed33b8e391691)
    },
    code: {
        regex: /`(.*?)`/gi,
        fn: (0, $a5e42debdb619001$export$2e2bcd8739ae039)
    },
    phone: {
        regex: new RegExp((0, $5625d0caec0a5724$export$a77dd7471651eee), "ig"),
        fn: (0, $19695571cfcc95c0$export$4c3f131968b69ab4)
    },
    link: {
        regex: /([a-z]+:\/\/)?((([^\s./?#]+\.)+[^\s./]+)(\/[^\s]*)?)/gi,
        fn: (0, $5bec2caf4e6d13e3$export$2ca3ffb384919372)
    },
    mention: {
        // regex: /(@[\w_\d.]+)/gi,
        regex: /\[.+?]\(mention:\/\/user_id\/(.+)\)/g,
        fn: (0, $9044c68812eeffbc$export$2e2bcd8739ae039)
    },
    identifier: {
        regex: /@[a-zA-Z][a-zA-Z0-9_]{4,31}\b/g,
        fn: (0, $7ecb579c7679222f$export$7b11aaab27e6da4b)
    },
    hashtag: {
        regex: (0, ($parcel$interopDefault($PJwWZ$hashtagregex)))(),
        fn: (0, $990bc7e57fd6f777$export$eddc145d3ae2075c)
    },
    hyperLink: {
        regex: /\[.+?]\((.+)\)/g,
        fn: (0, $160c5f374e056dc2$export$f67d7f85eca31cc4)
    },
    customLink: {
        regex: "",
        fn: (0, $5bec2caf4e6d13e3$export$2ca3ffb384919372)
    }
};
const $47656169c492d9d8$var$getParser = (parser, query, links)=>{
    if ($PJwWZ$ramda.is(String, parser)) {
        if (parser === "highlight") {
            if (!query) return {};
            return {
                regex: new RegExp(query, "ig"),
                fn: (0, $1755f040633aa4a7$export$2e2bcd8739ae039)
            };
        }
        if (parser === "emoji" || parser === "hashtag" || parser === "link" || parser === "identifier" || parser === "hyperLink" || parser === "phone") return null;
        return $47656169c492d9d8$export$ecc56c680df52e50[parser];
    }
    if ($PJwWZ$ramda.is(Object, parser)) {
        const defaultParser = $47656169c492d9d8$export$ecc56c680df52e50[parser.name];
        const tempParser = defaultParser ? $PJwWZ$ramda.mergeRight(defaultParser, parser) : parser;
        if (parser.name === "customLink") {
            // Filter out empty strings from links
            const validLinks = (links === null || links === void 0 ? void 0 : links.filter((link)=>link && link.trim() !== "")) || [];
            if (validLinks.length > 0) return {
                regex: new RegExp(validLinks.map($47656169c492d9d8$var$escapeRegExp).join("|"), "ig"),
                fn: parser.fn || (0, $5bec2caf4e6d13e3$export$2ca3ffb384919372)(parser.args)
            };
            // Return empty string for regex if no valid links
            return {
                regex: "",
                fn: parser.fn || (0, $5bec2caf4e6d13e3$export$2ca3ffb384919372)(parser.args)
            };
        }
        if (parser.name === "highlight") {
            if (!query) return {};
            return {
                regex: new RegExp(query, "ig"),
                fn: parser.fn || (0, $1755f040633aa4a7$export$2e2bcd8739ae039)
            };
        }
        return {
            ...tempParser,
            fn: parser.fn || tempParser.fn(parser.args)
        };
    }
    return null;
};
const $47656169c492d9d8$export$8d21e34596265fa2 = ({ query: query , parsers: parsers , links: links  })=>$PJwWZ$ramda.filter(Boolean, $PJwWZ$ramda.map((parser)=>$47656169c492d9d8$var$getParser(parser, query, links), parsers));
function $47656169c492d9d8$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") // $& means the whole matched string
    ;
}


const $547b71b758d2d1c0$export$45abb64cb9f69786 = ({ text: text , parsers: parsers , query: query , links: links  })=>text ? (0, ($parcel$interopDefault($PJwWZ$reactprocessstring)))((0, $47656169c492d9d8$export$8d21e34596265fa2)({
        parsers: parsers,
        query: query,
        links: links
    }))(text.trim()) : "";
$547b71b758d2d1c0$export$45abb64cb9f69786.propTypes = {
    text: (0, ($parcel$interopDefault($PJwWZ$proptypes))).string,
    parsers: (0, ($parcel$interopDefault($PJwWZ$proptypes))).arrayOf((0, ($parcel$interopDefault($PJwWZ$proptypes))).oneOfType([
        (0, ($parcel$interopDefault($PJwWZ$proptypes))).shape({
            name: (0, ($parcel$interopDefault($PJwWZ$proptypes))).string,
            regex: (0, ($parcel$interopDefault($PJwWZ$proptypes))).instanceOf(RegExp),
            fn: (0, ($parcel$interopDefault($PJwWZ$proptypes))).func
        }),
        (0, ($parcel$interopDefault($PJwWZ$proptypes))).oneOf([
            "emoji",
            "code",
            "link",
            "mention",
            "hashtag",
            "highlight",
            "hyperlink",
            "customLink"
        ]), 
    ])),
    query: (0, ($parcel$interopDefault($PJwWZ$proptypes))).string,
    links: (0, ($parcel$interopDefault($PJwWZ$proptypes))).arrayOf((0, ($parcel$interopDefault($PJwWZ$proptypes))).string)
};
$547b71b758d2d1c0$export$45abb64cb9f69786.defaultProps = {
    text: "",
    parsers: [
        "emoji",
        "code",
        "link",
        "hashtag",
        "highlight"
    ],
    query: "",
    links: []
};






//# sourceMappingURL=main.js.map
